import React from 'react';
import './Product.css';
import StarRateIcon from '@material-ui/icons/StarRate';
import { useStateValue } from './StateProvider';
import Fade from 'react-reveal/Fade';


function Product({ id, title, image, price, rating  }) {
    const [{basket}, dispatch] = useStateValue();

    const addToCart = () => {
        dispatch({
            type: 'ADD_TO_CART',
            item: {
                id: id,
                title: title,
                image: image,
                price: price,
                rating: rating
            },
        });
    };
    
    return (
        <div className="product">
            <Fade bottom>
            <div className=
                "product_info">
                <p>{title}</p>
                <p className="product_price">
                    Ksh.<strong>{price}</strong>
                </p>

                <p className="product_rating">
                    {Array(rating).fill().map((_, i) => (
                    
                        <span><StarRateIcon/></span>
                    ))}
                </p>
                
            </div>
            <div className="product_img">
                <img src={image} alt="tcl smart tv"/>
            </div>
         
            <button onClick={addToCart}>Add to Cart</button>
            </Fade>
        </div>
    )
}

export default Product
